import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/AboutUsCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Newsletter"] */ "/opt/build/repo/src/components/Newsletter/Newsletter.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/Partners/Partners.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/[locale]/homepage.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/ui/Accordion/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ButtonLink"] */ "/opt/build/repo/src/components/ui/Button/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/ui/HeroBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageContent"] */ "/opt/build/repo/src/components/ui/PageContent/PageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/WhatWeOffer/WhatWeOffer.tsx");
